import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonService } from 'src/app/services/common.service';

export interface AccountingInfo {
  chargeTotal: number;
  discountTotal: number;
  invoiceAmount: number;
  referralAmount?: number;
  clientMarketingAmount?: number;
}
@Component({
  selector: 'app-accounting-charge-summary',
  standalone: false,
  templateUrl: './accounting-charge-summary.html',
  styleUrls: ['./accounting-charge-summary.scss'],
})
export class AccountingChargeSummary {
  @Input() accountingInfo: AccountingInfo | null = null;
  @Input() showAdminFields = false; // SUPERUSER / TECH_ADMIN

  constructor(public commonService: CommonService) {}
}
